import { isValidElement } from 'react';
/**
 * 是否是指定的sinoui组件
 *
 * @export
 * @param {*} element
 * @param {string[]} sinouiNames
 * @returns
 */
export default function isSinouiElement(element, sinouiNames) {
    var type = isValidElement(element) &&
        element.type;
    return isValidElement(element) && sinouiNames.indexOf(type.sinouiName) !== -1;
}
//# sourceMappingURL=reactHelpers.js.map